import { goreloManagedEmailHostSet } from "./runtime-api-url-box";

function readEmailHostPrefix(): string {
  if (typeof window !== "undefined") {
    const w = (window as Record<string, string | undefined>).emailHostPrefix;
    if (w) {
      return w;
    }
  }
  return (import.meta.env as Record<string, string | undefined>).VITE_emailHostPrefix || "";
}

export function stripEmailHostPrefixFromDomain(domain: string): string {
  const prefix = readEmailHostPrefix();
  if (prefix && domain.startsWith(prefix)) {
    return domain.substring(prefix.length);
  }
  return domain;
}

export function isGoreloManagedEmailDomain(domain: string): boolean {
  if (!domain) {
    return false;
  }
  return goreloManagedEmailHostSet().has(stripEmailHostPrefixFromDomain(domain));
}
